exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-title[data-v-b9b86b82]{text-align:center}.card-title p[data-v-b9b86b82]{font-size:1.5rem;color:#fff}.card-content>p[data-v-b9b86b82]{margin-top:1rem;color:#fff;font-size:36px;font-weight:400;text-align:center}", ""]);

// exports
